import { compose } from 'recompose';

import SubscribersList from './SubscribersList';

const enhance = compose();

export default enhance(SubscribersList);
